export default __webpack_public_path__ + "static/carMobile-a6f703e9a74419526f5fa39d624d0227.webp";